module.exports = __webpack_public_path__ + "img/rank.c7166b97.png";